import { Flex, Box } from '@chakra-ui/react';
import React from 'react';
import { chatListTime } from '../../utils/helper';
import { Body, Caption, Subtitle } from '../Texts/Texts';
import { colors } from '../../theme/colors';

interface ChatListItemProps {
  active?: boolean;
  name?: string;
  time?: string;
  type?: string;
  message?: string;
  count?: string | number;
  onClick?: () => void;
}

const ChatListItem = ({
  active,
  name,
  time,
  message,
  count,
  onClick
}: ChatListItemProps) => {

  // Determine status color based on time
  const getStatusColor = (time: string) => {
    if (!time) return 'gray.400';
    const messageTime = new Date(time);
    const now = new Date();
    const diffInHours = (now.getTime() - messageTime.getTime()) / (1000 * 60 * 60);
    
    if (diffInHours < 1) return 'green.500';
    if (diffInHours < 24) return 'blue.500';
    return 'gray.400';
  };

  return (
    <Flex
      h='80px'
      p='16px'
      mb='8px'
      borderRadius='12px'
      bg={active ? colors.deep_blue : 'white'}
      color={active ? 'white' : 'black'}
      cursor='pointer'
      onClick={onClick}
      _hover={{
        bg: active ? colors.deep_blue : 'gray.50',
        transform: 'translateY(-1px)',
        boxShadow: active ? '0 4px 12px rgba(5, 57, 107, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.1)'
      }}
      transition='all 0.2s ease'
      boxShadow={active ? '0 2px 8px rgba(5, 57, 107, 0.2)' : '0 1px 3px rgba(0, 0, 0, 0.1)'}
      border={active ? 'none' : '1px solid #e2e8f0'}
    >

      {/* Content */}
      <Flex flex={1} flexDirection='column' justifyContent='space-between' minW={0}>
        {/* Header with name and time */}
        <Flex justifyContent='space-between' alignItems='flex-start' mb='4px'>
          <Body
            size='15px'
            fontWeight={600}
            color={active ? 'white' : colors.deep_blue}
            textTransform='capitalize'
            noOfLines={1}
            flex={1}
            mr='8px'
          >
            {name || 'Unknown User'}
          </Body>
          {time && (
            <Caption 
              color={active ? 'white' : 'gray.500'} 
              fontSize='12px'
              fontWeight={500}
              flexShrink={0}
            >
              {chatListTime(time)}
            </Caption>
          )}
        </Flex>

        {/* Message and status */}
        <Flex justifyContent='space-between' alignItems='center'>
          <Subtitle
            size='13px'
            fontWeight={400}
            color={active ? 'white' : 'gray.600'}
            noOfLines={1}
            flex={1}
            mr='8px'
          >
            {message || 'No messages yet'}
          </Subtitle>
          
          {/* Status indicator and count */}
          <Flex alignItems='center' gap='8px'>
            {/* Online status indicator */}
            {time && (
              <Box
                w='8px'
                h='8px'
                borderRadius='50%'
                bg={getStatusColor(time)}
                flexShrink={0}
              />
            )}
            
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ChatListItem;
